import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { PrismicRichText } from '@prismicio/react'

const Table = ({ slice }) => {
  return (
    <section className='component-table relative mx-auto max-w-screen-xl py-3 px-4'>
      <div className='prose prose-blue min-w-full'>
        <PrismicRichText field={slice.primary.text.richText} />
      </div>
      {slice.items.map((table, index) => {
        return (
          <div key={`table-${index}`} className='my-5 overflow-hidden rounded-md border-0 bg-white shadow-sm'>
            <ReactMarkdown children={table.markdown.text} remarkPlugins={[remarkGfm]} />
          </div>
        )
      })}
    </section>
  )
}

export default Table
